<style lang="stylus">
.follow-wechat
     height 100vh
     width 100%
     background-color rgba(0,0,0,.6)
     position absolute
     top 0
     z-index 1000
     color rgb(255,255,255)
     display flex
     flex-direction column
     align-items center
     padding 14px 2.7vw 0
     .follow-wechat-title
         margin 25px 0
         font-size 17px
     .follow-wechat-line
         width 76%
         height 1px
         border-top 1px dashed #fff
     .follow-wechat-close-button
         align-self flex-start
         img
             height 19px
             width 19px
     .follow-wechat-qrcode
         img
             width 46.7vw
             height 46.7vw
             margin auto 0
     .follow-wechat-qrcode-msg
         font-size 13px
         margin 22px 0 30px
     .follow-wechat-msg
         div:first-child
             font-size 15px
             margin 30px 0 10px
         ul
             padding-left: 0px;
             li
                 list-style: none
                 span
                     font-size 20px
                     line-height: 10px;
         div:not(first-child)
             font-size 13px
</style>
<template>
  <div class="follow-wechat" v-if="pageShow">
    <div class="follow-wechat-close-button" @click="closePage">
      <img src="../../image/preorder/close-page.png" alt="" />
    </div>
    <div class="follow-wechat-title" v-if="parentPage == 'preorder'">
      关注公众号，掌握更多订单信息
    </div>
    <div class="follow-wechat-title" v-else>
      关注公众号，用券更方便
    </div>
    <div class="follow-wechat-qrcode">
      <img :src="qrCode" alt="" />
    </div>
    <div class="follow-wechat-qrcode-msg">长按识别二维码，关注公众号</div>
    <div class="follow-wechat-line"></div>
    <div class="follow-wechat-msg" v-if="parentPage == 'preorder'">
      <div>关注公众号后，您将获得</div>
      <ul>
        <li><span>· </span>更多精挑细选的优质商品，更多优惠</li>
        <li><span>· </span>每周推送精编购物指南</li>
        <li><span>· </span>在线一对一客服</li>
      </ul>
    </div>
    <div class="follow-wechat-msg" v-else>
      <div>查看绑定的券</div>
      <ul>
        <li><span>· </span>关注公众号，进入优选商城</li>
        <li><span>· </span>点击「我的」，查看「苏打券」</li>
        <li><span>· </span>即可查看您绑定的券</li>
      </ul>
    </div>
  </div>
</template>
<script>
import cookie from '../lib/cookie.js'
import CONSTANT from '../constant/cookie.js'
import nomQrCode from '../../image/preorder/qrcode-yx.jpg'
import vipQrCode from '../../image/preorder/qrcode-yx-vip.jpg'
import { app } from '../util/platform'
import { mapActions, mapState } from 'vuex'
import { getHostName } from '../util/function.js'

// import nomQrCode from '../../image/preorder/test.jpg'
// import vipQrCode from '../../image/preorder/test-vip.png'

export default {
  props: ['page'], //page= 1 ,表示在结算页面中； page = 2 表示在卡详情页中; page = 3 表示在卡查询有页
  data() {
    return {
      pageShow: false,
      qrCode: {},
      parentPage: 'card',
      queryContent: {
        content: '',
        type: 0,
      },
    }
  },
  created() {
    this.qrCode = this.getQrCode()
  },
  mounted() {
    if (this.page == '1') {
      this.parentPage = 'preorder'
      // this.isPageShow();
    }
  },
  computed: {
    ...mapState({
      cardContent: state => state.card.cardDetail.contentData,
    }),
  },
  methods: {
    ...mapActions(['isFollowedWechat', 'sendWechatMsgTpl']),
    async isPageShow(urlQuery) {
      // FIXME: 暂时屏蔽强制关注微信公众号
      return false

      if (!app.isWechat()) {
        return false
      }
      if (await this.isFollowed()) {
        return false
      }
      if (this.page != '3') {
        urlQuery = this.cardContent
      }
      this.pageShow = true
      await this.sendTemplateMsg(urlQuery)
      return true
    },
    getQrCode() {
      let co = cookie(CONSTANT.COOKIE_CO)
      if (co == CONSTANT.COOKIE_CO_IS_SDYXVIP) {
        return vipQrCode
      }
      return nomQrCode
    },
    async isFollowed() {
      //检验是否已经关注公众号
      let openId = this.getOpenId()
      return await this.isFollowedWechat({
        openId: openId, //cookie(CONSTANT.COOKIE_CO)== CONSTANT.COOKIE_CO_IS_SDYXVIP?'oanMkt03UwwEhcsgNEj73__BHpWQ'/* 'oanMktyw6Q7S7W5tcsNTOsCyX--M' */:'oAyWr0ifcQUl6Uil7GZe-kI2r9qU'/* 'oAyWr0vCwE1ipDQViZ7ywiKQBJcc' */,
      }).then(data => {
        return data.isSubscribed == 1 ? true : false
      })
    },
    async sendTemplateMsg(urlQuery) {
      //发送微信回调地址
      let url, type
      let co = cookie(CONSTANT.COOKIE_CO)
      if (this.$route.name != 'preorder') {
        let content = urlQuery.content
        url = `${getHostName()}/v5/?co=${co}#/card/query?type=${urlQuery.type}&content=${encodeURIComponent(content)}&contentType=1`
        type = 2
      } else {
        url = window.location.href
        type = 1
      }

      let openId = this.getOpenId()
      await this.sendWechatMsgTpl({
        openId: openId, //cookie(CONSTANT.COOKIE_CO)== CONSTANT.COOKIE_CO_IS_SDYXVIP?'oanMkt03UwwEhcsgNEj73__BHpWQ'/* 'oanMktyw6Q7S7W5tcsNTOsCyX--M' */:'oAyWr0ifcQUl6Uil7GZe-kI2r9qU'/* 'oAyWr0vCwE1ipDQViZ7ywiKQBJcc' */,//
        type: type,
        content: {
          url: url,
        },
      })
    },
    getOpenId() {
      return cookie(CONSTANT.COOKIE_CO) == CONSTANT.COOKIE_DEFAULT_CO ||
        cookie(CONSTANT.COOKIE_CO) == CONSTANT.COOKIE_CO_IS_SDYXVIP ||
        cookie(CONSTANT.COOKIE_CO) == CONSTANT.COOKIE_CO_IS_MZVIP
        ? cookie(CONSTANT.COOKIE_USER_THIRD_OPENID)
        : cookie(CONSTANT.COOKIE_DEFAULT_SDYX_OPENID)
    },
    closePage() {
      this.pageShow = false
      this.$emit('followWC-page-close')
    },
  },
}
</script>
